/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Property_List_RegistryInputs */

const cs_property_list_registry = /** @type {(inputs: Property_List_RegistryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kontroly registrů`)
};

const en_property_list_registry = /** @type {(inputs: Property_List_RegistryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Registry checks`)
};

/**
* | output |
* | --- |
* | "Registry checks" |
*
* @param {Property_List_RegistryInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const property_list_registry = /** @type {((inputs?: Property_List_RegistryInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Property_List_RegistryInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_property_list_registry(inputs)
	return cs_property_list_registry(inputs)
});